module.exports = __webpack_public_path__ + "static/media/graphql.b6b6c04b.svg";